let memoryStore = [];

export function storeIncidentMemory(entry) {
  memoryStore.unshift({
    id: Date.now(),
    ...entry,
  });

  memoryStore = memoryStore.slice(0, 100); // keep last 100
}

export function querySimilarIncidents(context) {
  if (!memoryStore.length) return [];

  return memoryStore.filter(m =>
    m.zone === context.zone ||
    Math.abs(m.fentanyl - context.fentanyl) < 1
  ).slice(0, 5);
}

export function getMemoryStats() {
  return {
    total: memoryStore.length,
  };
}
